import { loadConfig } from '../../../../utils/configLoader';

/**
 * Flag runtime `venta_presencial_enabled` (react_config.json). Apagado (o
 * ausente) por default: la ruta `/auto/vendedor` responde como cualquier
 * ruta desconocida (ver `VendedorGate`). A diferencia de `auto_via_bff`, NO
 * está restringido a Argentina: el módulo es partner-agnóstico.
 */
export const isVentaPresencialEnabled = async (): Promise<boolean> => {
  try {
    const config = await loadConfig();
    return config?.venta_presencial_enabled === true;
  } catch {
    return false;
  }
};

